import { useQuery } from "@apollo/react-hooks";
import { GetBrandDetails } from "./queries";

export const useBrandPage = ({ username }) => {
  const { data, loading } = useQuery(GetBrandDetails, {
    variables: { username },
    skip: !username
  });

  const account = data && data.accounts && data.accounts[0];

  const preference = account && account.preference;
  const programFeatures =
    (preference && JSON.parse(preference.programFeatures)) || [];

  const opportunities = (account && account.activeOpportunities) || [];

  return {
    account,
    preference,
    programFeatures,
    opportunities,
    loading
  };
};
